// client/src/api/lockedSummary.ts
import { ServerError } from '@/lib/http';
import { parseRetryAfterHeader } from '@/lib/transientApiErrors';
export type LockedOperator = { id: number; name: string };
export type LockedFormat = { formatId: number|null; formatName: string; operators: LockedOperator[] };
export type LockedSummary = {
  cycle: number;
  store: { id: number; name: string };
  byFormat: LockedFormat[];
  storeOperators: LockedOperator[];
};

export async function getLockedSummary(cycleId: number, storeId: number): Promise<LockedSummary> {
  const res = await fetch(`/api/debug/locked-summary/${cycleId}/${storeId}`, { credentials: 'omit' });
  if (!res.ok) throw new Error(`locked-summary failed ${res.status}`);
  return res.json();
}

export type CycleSnapshotMeta = {
	id: string;
	cycleId: number;
	createdAt: string;
	createdByUserId: string;
	note?: string;
};

export type CycleSnapshotResponse = {
	meta: CycleSnapshotMeta;
	data: any[]; // SignOffV2 flat rows shape
};

export async function getCycleSnapshots(cycleId: string | number): Promise<CycleSnapshotMeta[]> {
	const res = await fetch(`/api/cycles/${cycleId}/snapshots`, { credentials: 'omit' });
	if (!res.ok) {
		const retryAfterMs = parseRetryAfterHeader(res.headers.get('Retry-After'));
		throw new ServerError(`/api/cycles/${cycleId}/snapshots`, res.status, retryAfterMs);
	}
	return res.json();
}

export async function getCycleSnapshot(snapshotId: string | number): Promise<CycleSnapshotResponse> {
	const res = await fetch(`/api/cycle-snapshots/${snapshotId}`, { credentials: 'omit' });
	if (!res.ok) {
		const retryAfterMs = parseRetryAfterHeader(res.headers.get('Retry-After'));
		throw new ServerError(`/api/cycle-snapshots/${snapshotId}`, res.status, retryAfterMs);
	}
	return res.json();
}
